import React from 'react';

interface ConicalIconProps {
  color?: string;
  className?: string;
}

const ConicalIcon: React.FC<ConicalIconProps> = ({ color, className }) => {
  const tubeColor = color || "#FFFFFF";

  return (
    <svg viewBox="0 0 24 27" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M16.5 4.71431H7.5C7.5 4.71431 6 15.5 4 19.5C2 23.5 2 24 2 24.5C2 25.5 5 26.3572 12 26.3572C19 26.3572 22 25.5 22 24.5C22 24 22 23.5 20 19.5C18 15.5 16.5 4.71431 16.5 4.71431Z" fill="#FFFFFF" stroke="#0C3058" strokeWidth="0.8"/>
      <path d="M17 4.71431H7C7 2.71431 7.4 0.642883 7.9 0.642883H16.1C16.6 0.642883 17 2.71431 17 4.71431Z" fill={tubeColor} stroke="#0C3058" strokeWidth="0.8"/>
      <path d="M16.5 4.71431H7.5" stroke="#0C3058" strokeWidth="0.4"/>
      <path d="M8 7H10" stroke="#0C3058" strokeWidth="0.4"/>
      <path d="M8 10H10" stroke="#0C3058" strokeWidth="0.4"/>
      <path d="M8 13H10" stroke="#0C3058" strokeWidth="0.4"/>
      <path d="M8 16H10" stroke="#0C3058" strokeWidth="0.4"/>
      <path d="M8 19H10" stroke="#0C3058" strokeWidth="0.4"/>
      <text x="11" y="7.3" fontFamily="Arial" fontSize="1.5" fill="#0C3058">15</text>
      <text x="11" y="10.3" fontFamily="Arial" fontSize="1.5" fill="#0C3058">12</text>
      <text x="11" y="13.3" fontFamily="Arial" fontSize="1.5" fill="#0C3058">9</text>
      <text x="11" y="16.3" fontFamily="Arial" fontSize="1.5" fill="#0C3058">6</text>
      <text x="11" y="19.3" fontFamily="Arial" fontSize="1.5" fill="#0C3058">3</text>
    </svg>
  );
};

export default ConicalIcon;
